import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImmigrationInformationComponent } from './immigration-information.component';
import { DateFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [ImmigrationInformationComponent],
  imports: [CommonModule, StaticMsgModule, DateFormatModule],
  exports: [ImmigrationInformationComponent],
})
export class ImmigrationInformationModule {}
